const contact = {
    title: 'Nhận hỗ trợ',
    description: 'Để được hỗ trợ hoặc góp ý về sản phẩm, vui lòng liên hệ chúng tôi qua các cách sau.',
    discord: {
        title: 'Tham gia cộng đồng Discord',
        description: 'Kết nối với các lập trình viên khác để tìm giải pháp',
        button: 'Tham gia',
    },
    github: {
        title: 'Trao đổi trên GitHub',
        description: 'Tạo issue và gửi trên GitHub',
        button: 'Mở',
    },
    email: {
        title: 'Liên hệ hỗ trợ qua email',
        description: 'Gửi email cho chúng tôi để biết thêm thông tin và được hỗ trợ',
        button: 'Gửi',
    },
    reserve: {
        title: 'Đặt lịch với đội ngũ sdvico',
        description: 'Nhanh chóng đặt một buổi trò chuyện trực tiếp',
        button: 'Đặt lịch',
    },
};
export default Object.freeze(contact);
